import { render, staticRenderFns } from "./AddMaterialSlot.vue?vue&type=template&id=ab6a57b6&scoped=true"
import script from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
export * from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
import style0 from "./AddMaterialSlot.vue?vue&type=style&index=0&id=ab6a57b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6a57b6",
  null
  
)

export default component.exports